<template>
  NOT FOUND
</template>

<script>
export default {
  name: "NotFoundComponent"
}
</script>

<style scoped>

</style>